export default __webpack_public_path__ + "static/media/abandoncart.e959a62e.svg";